/** 报告类型：月测 / 周测（与接口 examType 一致） */
export const REPORT_MONTH = 4;
export const REPORT_WEEK = 5;

export function createEmptySharedFilters() {
    return {
        termKey: null,
        reportValue: null,
        monthDefType: null,
        weekDefType: null,
    };
}

export function hasSharedTermKey(filters) {
    return filters && filters.termKey != null && filters.termKey !== '';
}

export function hasSharedReportValue(filters) {
    return filters && filters.reportValue != null && filters.reportValue !== '';
}

export function normalizeReportValue(val) {
    if (val == null || val === '') return null;
    const n = Number(val);
    return Number.isNaN(n) ? null : n;
}

export function getRoutePreferredReportValue(routeQuery) {
    const q = routeQuery || {};
    if (q.reportValue != null && q.reportValue !== '') {
        return normalizeReportValue(q.reportValue);
    }
    if (q.testType != null && q.testType !== '' && q.fromType === 'multiRole') {
        return normalizeReportValue(q.testType);
    }
    return null;
}

export function pickDefTypeFromList(list, preferredDefType) {
    if (!list || list.length === 0) return null;
    if (preferredDefType != null && preferredDefType !== '' && !Number.isNaN(Number(preferredDefType))) {
        const found = findDefTypeRow(list, preferredDefType);
        if (found) {
            return found.defType != null ? Number(found.defType) : Number(found.id);
        }
    }
    const first = list[0];
    return first.defType != null ? Number(first.defType) : Number(first.id);
}

export function findDefTypeRow(list, defType) {
    return (list || []).find(item =>
        Number(item.defType) === Number(defType) || Number(item.id) === Number(defType)
    );
}

function resolveExamIdForEmit(reportValue, examType, localValue, sharedFilters, sharedKey) {
    if (Number(normalizeReportValue(reportValue)) !== examType) return null;
    if (localValue != null && localValue !== '') return Number(localValue);
    if (sharedFilters && sharedFilters[sharedKey] != null && sharedFilters[sharedKey] !== '') {
        return Number(sharedFilters[sharedKey]);
    }
    return null;
}

export function buildSharedFiltersPayload(termKey, reportValue, monthDefType, weekDefType, sharedFilters = null) {
    const normalizedReportValue = normalizeReportValue(reportValue);
    return {
        termKey: termKey != null && termKey !== '' ? Number(termKey) : null,
        reportValue: normalizedReportValue,
        monthDefType: resolveExamIdForEmit(
            normalizedReportValue, REPORT_MONTH, monthDefType, sharedFilters, 'monthDefType'
        ),
        weekDefType: resolveExamIdForEmit(
            normalizedReportValue, REPORT_WEEK, weekDefType, sharedFilters, 'weekDefType'
        ),
    };
}

export function createEmptyTeaSharedFilters() {
    return {
        ...createEmptySharedFilters(),
        classId: null,
    };
}

export function hasSharedClassId(filters) {
    return filters && filters.classId != null && filters.classId !== '';
}

export function buildTeaSharedFiltersPayload(termKey, reportValue, monthDefType, weekDefType, classId, sharedFilters = null) {
    return {
        ...buildSharedFiltersPayload(termKey, reportValue, monthDefType, weekDefType, sharedFilters),
        classId: classId != null && classId !== '' ? Number(classId) : null,
    };
}

/** 路由 query.gradeId 实际为班级 classId（sonOrgList.bindId） */
export function getRouteClassId(routeQuery) {
    const q = routeQuery || {};
    if (q.gradeId != null && q.gradeId !== '') {
        return Number(q.gradeId);
    }
    return null;
}

export function isUploadRoute(routeQuery) {
    return (routeQuery || {}).source === 'upload';
}

export function getRoutePreferredTermKey(routeQuery) {
    const q = routeQuery || {};
    if (isUploadRoute(q) && q.termValue != null && q.termValue !== '') {
        return Number(q.termValue);
    }
    return null;
}

export function getPreferredClassId(sharedFilters, routeQuery) {
    if (hasSharedClassId(sharedFilters)) {
        return Number(sharedFilters.classId);
    }
    return getRouteClassId(routeQuery);
}

export function resolveEmitClassId(localClassId, sharedFilters, routeQuery) {
    if (localClassId != null && localClassId !== '') {
        return Number(localClassId);
    }
    if (hasSharedClassId(sharedFilters)) {
        return Number(sharedFilters.classId);
    }
    return getRouteClassId(routeQuery);
}

export function findClassInGradeList(gradeList, classId) {
    return (gradeList || []).find(item => Number(item.bindId) === Number(classId));
}

/** 从班名（如「三年级4班」）提取年级名 */
export function extractGradeNameFromClassLabel(classLabel) {
    if (!classLabel) return '';
    const match = String(classLabel).match(/^(一年级|二年级|三年级|四年级|五年级|六年级)/);
    return match ? match[1] : '';
}

/** 月测/周测列表：兼容 defType 与 id（教师端接口常用 id） */
export function pickExamIdFromList(list, preferredId) {
    return pickDefTypeFromList(list, preferredId);
}

export function findExamRow(list, examId) {
    return findDefTypeRow(list, examId);
}
